module.exports = __webpack_public_path__ + "img/copy.55751342.svg";